import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/interval';
import {Http} from '@angular/http';
import {Router} from "@angular/router";
import {Injectable} from "@angular/core";


@Injectable()
export class AdminService {

  isAuthentificate: boolean = false;

  constructor (
               private http:Http,
               public router: Router){}


  public checkAdmin(Password: number): Observable<any> {
    return this.http.post('/api/admin/login', {password: Password});
  };

  public  isLoggined(): boolean {
    if (this.isAuthentificate) {
      return this.isAuthentificate;
    }
    else {
      this.router.navigate(['/admin/login']);
    }
  };

  public authenticate(): void {
    this.isAuthentificate = true;
  };


}












// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/services/adminLogin.service.ts